'use strict';

angular.module('app').directive('bookNow', function($http, $compile, GTM) {
    return {
        restrict: 'A',
        link: function(scope, elem) {
            $(elem).click(function(e) {
                if (scope.haveProducts) {
                    return true;
                }

                e.preventDefault();

                $http.get('/templates/_get_a_quote.html').then(function(response) {
                    if (response.status === 200) {
                        var template = $compile(angular.element(response.data))(scope);

                        GTM.event('user_bookig_enquiry_open');

                        jQuery.fancybox({
                            content: template,
                            type: 'html',
                            padding: 40,
                            wrapCSS: 'form-popup',
                            maxWidth: '760'
                        });
                    }
                });
            });
        }
    };
});